import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {PagesService} from '../services/pages.service';

@Injectable({
  providedIn: 'root'
})
export class ServiziGuard implements CanActivate {

  constructor(private _pagesService: PagesService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this. _pagesService.hasServices();
  }

}
